import { css } from '@eti/styles';
import { Stack } from '@etg/wings';
import { useSnowplowTracking } from '@eti/providers';
import { useToggle } from '../../../../../../../common/custom-hooks/toggle';
import type { TicketPriceInfoProps } from '../../model';
import { TicketPriceInfoModal } from './TicketPriceInfoModal';
import { PriceInfoLabel } from './PriceInfoLabel';

const stackStyles = css`
  cursor: pointer;
`;

export const TicketPriceInfo = ({
  className = stackStyles,
  isAtBottom = false,
  isMultipleTickets = false,
  isRyanAirTicketingOrMarketingCarrierPresent,
  isVI,
  priceLabelStyle = '',
  ticket,
  ticketPriceModalInfo,
  ticketVersion,
}: TicketPriceInfoProps) => {
  const { isOpen, handleOpen, handleClose } = useToggle();
  const { isSnowplowTrackingEnabled, sendTrackEvent } = useSnowplowTracking();

  const handlePriceBreakdownOpen = () => {
    handleOpen();
    if (isSnowplowTrackingEnabled) {
      sendTrackEvent({
        category: 'Results',
        action: 'Click',
        label: 'Price information',
      });
    }
  };

  return (
    <>
      <Stack className={className} onClick={handlePriceBreakdownOpen} spacing={0}>
        <PriceInfoLabel
          isAtBottom={isAtBottom}
          isMultipleTickets={isMultipleTickets}
          priceLabelStyle={priceLabelStyle}
          ticket={ticket}
          ticketVersion={ticketVersion}
        />
      </Stack>
      {ticketPriceModalInfo && (
        <TicketPriceInfoModal
          handleClose={handleClose}
          isOpen={isOpen}
          isRyanAirTicketingOrMarketingCarrierPresent={isRyanAirTicketingOrMarketingCarrierPresent}
          isVI={isVI}
          ticket={ticket}
          ticketPriceModalInfo={ticketPriceModalInfo}
        />
      )}
    </>
  );
};
